import {
    BusinessUnitSchema,
    CommandSchema,
    IdDescriptionItemSchema,
    IWorklistAiDataSchema,
    IWorklistFeaDataSchema,
    IWorklistPatientSchema,
    ProvenanceExSchema,
    SeveritySchema,
    UserExSchema,
} from './iworklist.validation';
import { ApExamination } from '../models/vnext.models';
import { z } from 'zod';

export const ApExaminationSchema = z
    .object({
        // From ICommonWorklistExaminationDTO (excluding patient)
        id: z.string(),
        idReport: z.string().nullable(),
        examinationDate: z.string().nullable(),
        reportDate: z.string().nullable(),
        approvalDate: z.string().nullable(),
        lastDate: z.string().nullable(),
        exam: IdDescriptionItemSchema,
        severity: SeveritySchema.nullable(),
        businessUnit: BusinessUnitSchema,
        provenance: ProvenanceExSchema,
        referringPhysician: UserExSchema.nullable(),
        secondReferringPhysician: UserExSchema.nullable(),
        status: z.string(),
        isApproved: z.boolean(),
        isDigitallySigned: z.boolean(),
        imageAvailability: z.boolean(),
        publicationAuthorization: z.boolean(),
        revaluedCDA: z.boolean().nullable().optional(),

        idLockedUser: z.string().nullable(),
        lockedHost: z.string().nullable(),
        lockedUserFullName: z.string().nullable(),

        idCustomPage: z.string().nullable(),
        idCustomPageRoot: z.string().nullable(),
        idModelTypeRoots: z.array(z.string()),
        referringPhysicianFullNameList: z.string().nullable(),
        reportedExaminationsNumber: z.number().nullable().optional(),
        command: CommandSchema,
        accessionNumber: z.string().nullable(),

        // From IWorklistExaminationSpecificDTO
        idEvent: z.string(),
        plannedDate: z.string().nullable(),
        admissionDate: z.string().nullable(),
        executionDate: z.string().nullable(),
        deliveryDate: z.string().nullable(),
        patientStatus: IdDescriptionItemSchema.nullable(),
        room: IdDescriptionItemSchema.nullable(),
        equipment: IdDescriptionItemSchema,
        agenda: IdDescriptionItemSchema.nullable(),
        technician: UserExSchema.nullable(),
        requestingPhysician: UserExSchema.nullable(),
        ticket: z.boolean(),
        admissionNumber: z.string().nullable(),
        externalAdmissionNumber: z.string().nullable(),
        folderNumber: z.string().nullable(),
        hospitalizationNumber: z.string().nullable(),
        reasonForStudy: z.string().nullable(),
        isExaminationLocked: z.number(),
        studyInstanceUid: z.string().nullable(),
        feaData: IWorklistFeaDataSchema.nullable(),
        hasDose: z.boolean(),
        aiData: IWorklistAiDataSchema.nullable(),
        modality: IdDescriptionItemSchema.nullable(),
        deliveryLocation: IdDescriptionItemSchema.nullable(),
        reportingDeadline: z.number().nullable(),
        patient: IWorklistPatientSchema,
        clinicalAlert: z.string().nullable().optional(), // @DTO_ERROR - cambiato perchè arriva null ma DTO (a BE) accetta solo string.
    })
    .strict();
export const validateApExamination = (data: unknown): ApExamination => {
    return ApExaminationSchema.parse(data) as ApExamination;
};

/*
alternative per il type checking tra zod schema e interfacce/tipi
// Utility type to ensure schema matches interface
type ValidateSchema<T, S extends z.ZodType<T>> = S;


* // Type that ensures T extends the inferred schema type and vice versa
type BidirectionalTypeCheck<T, S extends z.ZodType<any>> =
    T extends z.infer<S>
        ? z.infer<S> extends T
            ? S
            : never
        : never;
* */
